"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBlinkingBgColorKeyframes = void 0;
var styled_components_1 = require("styled-components");
var StyledComponentsTheme_1 = require("./StyledComponentsTheme");
var createBlinkingBgColorKeyframes = function (from, to) {
    if (from === void 0) { from = StyledComponentsTheme_1.THEME.colors.secondary.VividSkyBlue10; }
    if (to === void 0) { to = StyledComponentsTheme_1.THEME.colors.secondary.VividSkyBlue50; }
    return styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    background-color: ", ";\n  }\n  50% {\n    background-color: ", ";\n  }\n  100% {\n    background-color: ", ";\n  }\n    "], ["\n  0% {\n    background-color: ", ";\n  }\n  50% {\n    background-color: ", ";\n  }\n  100% {\n    background-color: ", ";\n  }\n    "])), from, to, from);
};
exports.createBlinkingBgColorKeyframes = createBlinkingBgColorKeyframes;
var templateObject_1;
//# sourceMappingURL=AnimationTheme.js.map